<template>
  <div class="container-fluid">
    <div class="row container-showcase align-start justify-space-between">
      <!--      player-->
      <v-col
        cols="12"
        class="wow fadeInLeftBig col-lg-7 col-xl-7 player"
        style="position: relative"
      >
        <player
          :poster-url="ctnShowcase.url_poster"
          :is-control-scene="true"
          :video-plr="video"
          @nextScene="onNextMainScene"
          @preScene="onPreMainScene"
        >
          <template v-slot:ads>
            <div v-for="(shop, idxShop) in shops" :key="idxShop">
              <div
                class="movingElement"
                :style="{
                  left: shop.x + 'px',
                  top: shop.y + 'px',
                  width: shop.width + 'px',
                  height: shop.height + 'px',
                }"
              >
                <div
                  @click="onclickBuyNow(shop)"
                  :id="shop.id"
                  style="position: relative; width: 100%; height: 100%"
                ></div>
              </div>
            </div>
          </template>
        </player>
        <content-same-showcase
          :title="ctnShowcase.title"
          :type-show-case="Number(ctnShowcase.type_showcase)"
          :showcase-id="ctnShowcase.showcase_id"
          @selectContent="handleChangeContent"
        />
      </v-col>
      <!--      panel-->
      <v-col cols="12" class="col-xl-5 col-lg-5">
        <div class="title-demo">
          <h5 v-html="`Demo ${$t('interactive_game_title')}`"></h5>
          <span>
            {{ $t("interactive_game_des") }}
          </span>
        </div>
        <transition name="slide-fade">
          <div class="wow fadeInRight" style="position: relative">
            <v-card
              width="100%"
              min-height="300px"
              height="auto"
              style="z-index: 2"
            >
              <v-card-text>
                <div class="pa-4" style="max-height: 600px; overflow-y: auto">
                  <div class="wow fadeInUp mb-2">
                    <v-row class="align-end justify-space-around">
                      <v-col
                        cols="auto"
                        v-for="(product, idx) in showcaseCr.metadata"
                        :key="idx"
                      >
                        <div class="filter-mark">
                          <div class="image-blur" :id="`${product.id}-image`">
                            <v-img :src="product.image" width="180px"></v-img>
                          </div>
                        </div>
                        <div
                          class="mt-2 pa-2 hide-info text-center"
                          :id="`${product.id}-info`"
                        >
                          <h5 style="font-size: 18px">{{ product.name }}</h5>
                          <span>{{ product.description }}</span>
                        </div>
                      </v-col>
                    </v-row>
                  </div>
                </div>
              </v-card-text>
            </v-card>
            <div class="close-panel" v-if="showPrPanel" role="user">
              <div class="title-panel-close justify-space-between">
                <small class="mr-4">Product panel</small>
              </div>
            </div>
          </div>
        </transition>
      </v-col>
    </div>
  </div>
</template>

<script>
import { playerShowcase } from "../../minxin/player-showcase";
import _ from "lodash";
import ContentSameShowcase from "./components/ContentSameShowcase";
import Player from "./components/Player";
import { mdiClose } from "@mdi/js";
export default {
  name: "CountClick",
  components: { Player, ContentSameShowcase },
  mixins: [playerShowcase],
  created() {
    switch (this.$vuetify.breakpoint.name) {
      case "lg":
        this.showPrPanel = true;
        this.slotPanel = true;
        break;
      case "xl":
        this.showPrPanel = true;
        this.slotPanel = true;
        break;
      default:
        this.showPrPanel = false;
        this.slotPanel = false;
        break;
    }
  },
  data() {
    return {
      showShopInfo: null,
      reload: 0,
      mdiClose: mdiClose,
      clickedData: [],
    };
  },
  watch: {
    shops(val) {
      console.log(val);
    },
    showShopInfo(val) {
      if (val === null) {
        this.plyr.play();
      }
    },
  },
  methods: {
    _getMetaDataInTime(data, currentTimeVideo) {
      /*
      So sanh và get meta data tại thời điểm  hiện tại video display
      */
      return (
        _.filter(data, (o) => {
          return (
            o["itv"][0] <= currentTimeVideo && o["itv"][1] >= currentTimeVideo
          );
        }) || []
      );
    },
    onclickBuyNow(shop) {
      let productCtn = document.getElementById(`${shop.id}`);
      let pyro = null;
      if (productCtn) {
        // let countLabel = document.createElement("div");
        let after = document.createElement("div");
        after.classList.add("after");
        pyro = document.createElement("div");
        pyro.classList.add("pyro");
        pyro.appendChild(after);
        // countLabel.innerText = "";
        // countLabel.classList.add("countLabel");
        // productCtn.appendChild(countLabel);
        productCtn.appendChild(pyro);
        setTimeout(() => {
          // productCtn.removeChild(countLabel);
          productCtn.removeChild(pyro);
          pyro = null;
          // countLabel = null;
        }, 800);
      }
      console.log(shop);
      if (
        _.find(this.showcaseCr.metadata, { id: shop.id }) &&
        !_.find(this.clickedData, { id: shop.id })
      ) {
        this.clickedData.push({
          id: shop.id,
          name: shop.name,
          image: shop.image,
          description: shop.description,
        });
        let imageHide = document.getElementById(`${shop.id}-image`);
        if (imageHide) {
          imageHide.classList.remove("image-blur");
          imageHide.classList.add("firework");
          imageHide.parentElement.style.outline = "none";
          if (pyro) {
            let dumPyro = pyro.cloneNode(true);
            dumPyro.style.overflow = "hidden";
            imageHide.parentElement.appendChild(dumPyro);
            setTimeout(() => {
              imageHide.removeChild(dumPyro);
              dumPyro = null;
            }, 800);
          }
        }
        let infoHide = document.getElementById(`${shop.id}-info`);
        if (infoHide) {
          infoHide.classList.remove("hide-info");
        }
      }
    },
    onNextScene() {},
    onPreScene() {},
  },
};
</script>

<style lang="scss">
@import "https://cdn.plyr.io/3.6.7/plyr.css";
@import "../../styles/player.scss";
@import "../../styles/new_tag.scss";
.countLabel {
  position: absolute;
  z-index: 999;
  color: yellow !important;
  font-size: 35px !important;
  top: 4px;
  right: 4px;
}
$particles: 50;
$width: 500;
$height: 500;

// Create the explosion...
$box-shadow: ();
$box-shadow2: ();
@for $i from 0 through $particles {
  $box-shadow: $box-shadow,
    random($width)-$width /
      2 +
      px
      random($height)-$height /
      1.2 +
      px
      hsl(random(360), 100, 50);
  $box-shadow2: $box-shadow2, 0 0 #fff;
}
@mixin keyframes($animationName) {
  @-webkit-keyframes #{$animationName} {
    @content;
  }

  @-moz-keyframes #{$animationName} {
    @content;
  }

  @-o-keyframes #{$animationName} {
    @content;
  }

  @-ms-keyframes #{$animationName} {
    @content;
  }

  @keyframes #{$animationName} {
    @content;
  }
}
@mixin animation-delay($settings) {
  -moz-animation-delay: $settings;
  -webkit-animation-delay: $settings;
  -o-animation-delay: $settings;
  -ms-animation-delay: $settings;
  animation-delay: $settings;
}
@mixin animation-duration($settings) {
  -moz-animation-duration: $settings;
  -webkit-animation-duration: $settings;
  -o-animation-duration: $settings;
  -ms-animation-duration: $settings;
  animation-duration: $settings;
}
@mixin animation($settings) {
  -moz-animation: $settings;
  -webkit-animation: $settings;
  -o-animation: $settings;
  -ms-animation: $settings;
  animation: $settings;
}
@mixin transform($settings) {
  transform: $settings;
  -moz-transform: $settings;
  -webkit-transform: $settings;
  -o-transform: $settings;
  -ms-transform: $settings;
}

.pyro > .after {
  position: absolute;
  width: 5px;
  height: 5px;
  left: 0;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  border-radius: 50%;
  box-shadow: $box-shadow2;
  @include animation(
    (
      1s bang ease-out backwards,
      1s gravity ease-in backwards,
      5s position linear backwards
    )
  );
}

.pyro > .after {
  @include animation-delay((0, 0, 0));
  @include animation-duration((1.25s, 1.25s, 6.25s));
}

@include keyframes(bang) {
  to {
    box-shadow: $box-shadow;
  }
}

@include keyframes(gravity) {
  to {
    @include transform(translateY(200px));
    opacity: 0;
  }
}
@include keyframes(position) {
  0%,
  19.9% {
    margin-top: 10%;
    margin-left: 40%;
  }
  20%,
  39.9% {
    margin-top: 40%;
    margin-left: 30%;
  }
  40%,
  59.9% {
    margin-top: 20%;
    margin-left: 70%;
  }
  60%,
  79.9% {
    margin-top: 30%;
    margin-left: 20%;
  }
  80%,
  99.9% {
    margin-top: 30%;
    margin-left: 80%;
  }
}
.filter-mark {
  padding: 12px;
  .image-blur {
    -webkit-filter: blur(10px) !important;
    -moz-filter: blur(5px) !important;
    -o-filter: blur(10px) !important;
    filter: blur(10px) !important;
  }
  outline: 1px solid gray;
  &:hover {
    transform: translateY(-10px);
  }
  overflow: hidden !important;
  transition: all 0.2s linear !important;
}
.hide-info {
  -webkit-filter: blur(5px) !important;
  -moz-filter: blur(5px) !important;
  -o-filter: blur(5px) !important;
  filter: blur(5px) !important;
  user-select: none;
  transition: all 0.2s linear !important;
}
</style>
